import withPermission from './withPermission'
import withAuthentication from './withAuthentication'

/**
 * Require authentication, or more granular roles, to render a component
 *
 * protect(SomeComponent)                        // Must be logged in
 * protect('ADMIN')(SomeComponent)               // Must have role "admin"
 * protect('CONSUMER')(SomeComponent)            // Must have role "consumer"
 * protect(['MERCHANT', 'ADMIN'])(SomeComponent) // Must have role of either "merchant" or "admin"
 */
export default function protect(
  allowedPermissions: string | string[] | React.ComponentType<any>
): any {
  if (Array.isArray(allowedPermissions) || typeof allowedPermissions === 'string') {
    return withPermission(allowedPermissions)
  } else {
    const ComponentConstructor = allowedPermissions
    return withAuthentication(ComponentConstructor)
  }
}
